import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { ThumbUp } from "@mui/icons-material";

/**
 * Send Reaction — Enviar reacao (emoji) a ultima mensagem.
 *
 * data.reactionEmoji: string — emoji da reacao (ex: "👍", "❤️", "😂")
 * data.reactionTarget: "last" | "first" — reagir a qual mensagem
 *
 * Saida: handle "a" (default)
 */
const SendReactionNode = memo(({ id, data, isConnectable, selected }) => {
  const emoji = data?.reactionEmoji || data?.emoji || "";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<ThumbUp />}
      title="Enviar Reacao"
      color="#AD1457"
      bgColor="#FCE4EC"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={170}
    >
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        background: "#fff", border: "1px solid #e0e0e0",
        borderRadius: 8, padding: "8px 16px",
      }}>
        <span style={{ fontSize: 32 }}>
          {emoji || "?"}
        </span>
      </div>
    </NodeWrapper>
  );
});

SendReactionNode.displayName = "SendReactionNode";
export default SendReactionNode;
